import type { FeedbackFormModel } from "design-system/components/FeedbackWidget/types";

import type { FeedbackPayload } from "./types";

const IMPRESSION_BY_SENTIMENT: Record<string, FeedbackPayload["impression"]> = {
  needs_work: "needs_improvement",
  okay: "its_okay",
  satisfied: "satisfactory",
};

export const fromFeedback = (model: FeedbackFormModel): FeedbackPayload => ({
  impression: IMPRESSION_BY_SENTIMENT[model.sentiment ?? ""] ?? "satisfactory",
  ratings: Object.entries(model.ratings)
    .filter(([, stars]) => stars > 0)
    .map(([key, stars]) => ({ key, stars })),
  text: model.comment,
});
